module.exports = __webpack_public_path__ + "img/nongMin3.4e26f6cb.png";